import React from 'react';
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PreviousMeetingsWidgetGamePlaceholder,} from "./previous-meetings-widget.game.placeholder";
import {PreviousMeetingsWidgetHeaderPlaceholder} from "./previous-meetings-widget.header.placeholder";
import {WithDevice} from "../../../../core/components/composers/with-device";

export class PreviousMeetingsWidgetPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
  isFullView: Boolean;
}

export const PreviousMeetingsWidgetPlaceholder = WithDevice((props: PreviousMeetingsWidgetPlaceholderProps) => {
  const games: Array<Object> = [];

  for (let i = 0; i < 5; i++) {
    games.push({
      key: i
    });
  }

  return (
    <div className={['previous-meetings-widget-placeholder-container',
      props.isFullView ? '.previous-meetings-widget-placeholder-full-view' : ''].join(' ')}>
      <PreviousMeetingsWidgetHeaderPlaceholder {...props}/>
      {
        games.map((game) => <PreviousMeetingsWidgetGamePlaceholder key={game.key} {...props}/>)
      }
    </div>
  )
});
